module.exports = __webpack_public_path__ + "img/selected5-min.4be6cbdc.png";